
export default class ReportingDeclaration{

    constructor(json) {
        this.id = json['id'];
        this.declaration = json['declaration'];
        this.version = json['version'];
        this.requiresNewSignature = json['requires-new-signature'];
        this.dateCreated = json['dateCreated'];
    }
}